$(document).on('ajax:success', '[data-poll]', function (evt) {
  const data = evt.detail[0]
  if (data.error) {
    alert(data.error)
    return
  }
  if (data.response) {
    $(this).closest('.poll').replaceWith(data.response)
  }
})

$(document).on('ajax:error', '[data-poll]', function () {
  alert($(this).data('error'))
})

$(function () {
  $('[name="poll_answer[id]"]').on('click', function () {
    $('.poll__action').find('[type="submit"]').attr('disabled', false)
  })
})
